import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import Buscando from 'Component/Admin/Buscando';
import { LegendaAdicionar, LegendaLista } from 'Component/Admin/Legenda';
import SemRegistros from 'Component/Admin/SemRegistros';
import Botao from 'Component/Botao';
import { useRecuperarLegendasQuery } from 'View/Service/Default/Legendas';

const Legendas = (): React.ReactElement => {
  const [modal, setModal] = useState<boolean>(false);
  const { id = 0 } = useParams<'id'>();

  const {
    data: { legendas } = {},
    isLoading,
    refetch,
  } = useRecuperarLegendasQuery({
    options: { unidade_de_aprendizagem_id: id },
  });

  return (
    <div className="animate__animated animate__fadeIn">
      <div className="mb-3 d-flex gap-2">
        <Botao icone="arrow-clockwise" onClick={refetch} />
        <Botao icone="plus-lg" tema="success" onClick={() => setModal(true)}>
          Legenda
        </Botao>
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={legendas?.length} />
      <div className="bg-white shadow-sm rounded">
        <div className="clip-rounded">
          {legendas?.map((legenda) => (
            <LegendaLista
              key={`${legenda.id}-${legenda.modificado}`}
              dados={legenda}
            />
          ))}
        </div>
      </div>
      <LegendaAdicionar
        unidadeDeAprendizagemId={id as number}
        exibir={modal}
        aoFechar={setModal}
      />
    </div>
  );
};

export default Legendas;
